import { render, staticRenderFns } from "./private_version.vue?vue&type=template&id=3a86c654&scoped=true&"
import script from "./private_version.vue?vue&type=script&lang=js&"
export * from "./private_version.vue?vue&type=script&lang=js&"
import style0 from "./private_version.vue?vue&type=style&index=0&id=3a86c654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86c654",
  null
  
)

export default component.exports